import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import { IconName } from '@lib/components/Modal/enums';
import { DocumentTabEnum } from '../enums';

type Props = {
  isEmptyState: boolean;
  isEmptyStateByFilter: boolean;
  isEmptyStateBySearch: boolean;
  onResetFilter: () => void;
  setSearchQuery: (v: string) => void;
  tabParam?: string;
};

function DocumentsEmptyState(props: Props) {
  const {
    isEmptyState,
    isEmptyStateByFilter,
    isEmptyStateBySearch,
    onResetFilter,
    setSearchQuery,
    tabParam,
  } = props;
  const { t } = useTranslation();

  if (isEmptyStateBySearch) {
    return (
      <EmptyState
        title={t('no-results-found')}
        text={t('no-results-found-text')}
        icon={IconName.SearchOff}
        actions={[
          <Button
            key="back"
            buttonText={t('go-back')}
            buttonType={ButtonTypes.primaryFilled}
            leftIcon="arrow_back"
            onClick={() => setSearchQuery('')}
          />,
        ]}
      />
    );
  }

  if (isEmptyStateByFilter) {
    return (
      <EmptyState
        title={t('no-results-found')}
        text={t('try-something-else')}
        icon={IconName.SearchOff}
        actions={[
          <Button
            key="back"
            buttonText={t('clear-filtering')}
            buttonType={ButtonTypes.primaryFilled}
            onClick={onResetFilter}
          />,
        ]}
      />
    );
  }

  if (isEmptyState) {
    let titleKey = 'no-documents-yet';
    let textKey = 'no-documents-user-text';

    if (tabParam === DocumentTabEnum.Favorites) {
      titleKey = 'no-favorite-documents-yet';
      textKey = 'no-favorite-documents-text';
    } else if (tabParam === DocumentTabEnum.Unread) {
      titleKey = 'no-unread-documents-yet';
      textKey = 'no-unread-documents-text';
    }

    return (
      <EmptyState
        title={t(titleKey)}
        text={t(textKey)}
        icon={IconName.Activate}
      />
    );
  }

  return null;
}

export default DocumentsEmptyState;
